import React from "react";
import no_data_found from "../assets/images/no_data_found.png";
export default function RecordNotFound(props) {
  return (
    <>
      <div className={`${props?.class ? "text-center" : "no-access-string"}`}>
        <img className="mx-auto" src={no_data_found} />
        <p className="mt-3">{`${props?.title} Not Found`}</p>
      </div>
    </>
  );
}
